import React from "react";

export default function Contact() {
  const [result, setResult] = React.useState<string>("");
  const onSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setResult("Sending....");
    
    const form = event.currentTarget; // Store the form reference
    const formData = new FormData(form);
  
    formData.append("access_key", "31a0186e-bc04-45fa-a675-4ee37e828254");
  
    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });
  
      const data = await response.json();
  
      if (data.success) {
        setResult("Form Submitted Successfully");
        form.reset(); // Use the stored form reference
      } else {
        console.error("Error", data);
        setResult(data.message);
      }
    } catch (error) {
      console.error("Submission error", error);
      setResult("An error occurred while submitting the form.");
    }
  };


  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4">
      <div className="bg-white shadow-xl rounded-xl px-8 pt-6 pb-8 mb-4 w-full max-w-md border-l-4 border-blue-400">
      <form
        onSubmit={onSubmit}
        className="mb-4"
      >
        <h2 className="text-2xl font-bold mb-6 text-center">Contact Me</h2>
        <div className="mb-4">
          <label
            htmlFor="name"
            className="block text-sm font-bold mb-2"
          >
            Name
          </label>
          <input
            type="text"
            name="name"
            id="name"
            required
            className="w-full px-3 py-2 bg-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-4">
          <label
            htmlFor="email"
            className="block text-sm font-bold mb-2"
          >
            Email
          </label>
          <input
            type="email"
            name="email"
            id="email"
            required
            className="w-full px-3 py-2 bg-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="mb-6">
          <label
            htmlFor="message"
            className="block text-sm font-bold mb-2"
          >
            Message
          </label>
          <textarea
            name="message"
            id="message"
            required
            rows={4}
            className="w-full px-3 py-2 bg-gray-200 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          ></textarea>
        </div>
        <div className="flex items-center justify-between">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            Submit
          </button>
        </div>
      </form>
      <span className="text-center mt-8">{result}</span>
      </div>
    </div>
  );
  
}
